import { render, staticRenderFns } from "./campLnquiriesList.vue?vue&type=template&id=8d543f9c&scoped=true&"
import script from "./campLnquiriesList.vue?vue&type=script&lang=js&"
export * from "./campLnquiriesList.vue?vue&type=script&lang=js&"
import style0 from "./campLnquiriesList.vue?vue&type=style&index=0&id=8d543f9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d543f9c",
  null
  
)

export default component.exports